<template>
  <div class="start">


<div class="tomrum">

</div>



<Vy1 v-if="vyNummer%2 == 0"/>
<Vy2 v-if="vyNummer%2 == 1"/>
  </div>

</template>

<script>


import Vy1 from './startvy/vy1.vue'
import Vy2 from './startvy/vy2.vue'

export default {
  name: 'StartPage',
  title () {
    return `Tysk Grammatik`
  },
  components: {
      Vy1,
      Vy2
  },
  props: {
    msg: String,
    },
    data() {
        return {
            vyNummer:0
        }
    },
    methods:{
      scrollToTop() {
    window.scrollTo(0,0);
  },
        bytVy: function() {
            var that=this;
            setInterval(function(){
                 that.vyNummer ++;
             }, 5000);
        }
    },
    mounted() {
      //this.scrollToTop();
        this.bytVy();
    },


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
    font-family: 'Lobster', cursive;
    margin:0;
    padding-top:10px;

}

.tomrum {

}

p {
    font-family: 'Lobster', cursive;
    color: black;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.start {
    min-height: 70vh;
}
</style>
